export default __webpack_public_path__ + "static/media/featured-item-21.643c1de3.png";